import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3ea60252")

_pushScopeId("data-v-3ea60252")
const _hoisted_1 = { class: "d-flex align-items-start gap-3" }
const _hoisted_2 = { class: "symbol symbol-45px symbol-circle flex-shrink-0" }
const _hoisted_3 = { class: "symbol-label fs-6 fw-bolder bg-light-primary text-primary" }
const _hoisted_4 = { class: "flex-grow-1 min-w-0" }
const _hoisted_5 = { class: "d-flex align-items-center justify-content-between gap-2 mb-1" }
const _hoisted_6 = { class: "fw-bold text-gray-900 text-truncate" }
const _hoisted_7 = { class: "text-muted fs-8 flex-shrink-0" }
const _hoisted_8 = { class: "text-muted fs-7 text-truncate mb-2" }
const _hoisted_9 = { class: "d-flex flex-wrap align-items-center gap-2" }
const _hoisted_10 = { class: "badge badge-light fw-semibold" }
const _hoisted_11 = {
  key: 0,
  class: "badge badge-light-success"
}
const _hoisted_12 = {
  key: 1,
  class: "badge badge-light-warning"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("button", {
    type: "button",
    class: ["prospect-inbox-row w-100 border-0 text-start px-4 py-4", { 'prospect-inbox-row--active': _ctx.selected }],
    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('select', _ctx.prospect)))
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("span", _hoisted_3, _toDisplayString(_ctx.initials), 1),
        _createVNode("div", {
          class: "symbol-badge d-flex align-items-center justify-content-center",
          style: { backgroundColor: _ctx.channel.color }
        }, [
          _createVNode("i", {
            class: [_ctx.channel.icon, "text-white fs-9"]
          }, null, 2)
        ], 4)
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("span", _hoisted_6, _toDisplayString(_ctx.displayName), 1),
          _createVNode("span", _hoisted_7, _toDisplayString(_ctx.timeLabel), 1)
        ]),
        _createVNode("div", _hoisted_8, _toDisplayString(_ctx.preview), 1),
        _createVNode("div", _hoisted_9, [
          _createVNode("span", {
            class: ["badge", _ctx.gradeBadgeClass]
          }, _toDisplayString(_ctx.gradeLabel), 3),
          _createVNode("span", _hoisted_10, _toDisplayString(_ctx.prospect.leadScore ?? 0), 1),
          (_ctx.aiActive)
            ? (_openBlock(), _createBlock("span", _hoisted_11, " AI "))
            : (_openBlock(), _createBlock("span", _hoisted_12, " Manual "))
        ])
      ])
    ])
  ], 2))
})